import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from '@atoms';

const buttonStyle = {
  width: '374px',
  height: '55px',
  fontSize: '18px',
  position: 'relative',
};

const iconStyle = {
  position: 'absolute',
  left: '23px',
  top: '25%',
};

const CreateButton = ({ onClickHandler, iconName, message }) => (
  <Button big style={buttonStyle} onClick={onClickHandler}>
    <Icon name={iconName} style={iconStyle} />
    <FormattedMessage {...message} />
  </Button>
);

CreateButton.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
};

export default CreateButton;



// WEBPACK FOOTER //
// ./components/organisms/Header/CreateButton.js